<template>
<div>
  <div id="baseInfoEdit" v-if="editFlag">
      <!--基本信息编辑-->
      <div id="inforView" class="pt15">
        <el-form class="el-form demo-form-inline" ref="baseInforForm" :model="baseInforForm" label-width="230px" label-position="right" :rules="baseInforRules">
          <el-row class="tr mb5">
            <el-col :span="11">
              <el-form-item prop="ywgsmc" label="Company Name">
                <el-input size="small" v-model="baseInforForm.ywgsmc" placeholder="Company Name"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="1">&nbsp;</el-col>
            <el-col :span="11">
              <el-form-item prop="ywgsjc" label="Company Short Name">
                <el-input size="small" v-model="baseInforForm.ywgsjc" placeholder="Company Short Name"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="1">&nbsp;</el-col>
          </el-row>
          <el-row class="tr mb5">
            <el-col :span="11">
              <el-form-item prop="yjdzxx" label="Company Address">
                <el-input size="small" v-model="baseInforForm.yjdzxx" placeholder="Company Address"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="1">&nbsp;</el-col>
            <el-col :span="11">
              <el-form-item prop="bgdh" label="Phone">
                <el-input size="small" v-model="baseInforForm.bgdh" maxlength="50" placeholder="Phone"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="1">&nbsp;</el-col>
          </el-row>
          <el-row class="tr mb5">
            <el-col :span="11">
              <el-form-item prop="reserve2" label="Postal Code">
                <el-input size="small" v-model="baseInforForm.reserve2" placeholder="Postal Code"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="1">&nbsp;</el-col>
            <el-col :span="11">
              <el-form-item prop="cz" label="Fax">
                <el-input size="small" v-model="baseInforForm.cz" placeholder="Fax"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="1">&nbsp;</el-col>
          </el-row>
          <el-row class="tr mb5">
            <el-col :span="11">
              <el-form-item prop="frdb" label="Legal Representative">
                <el-input size="small" v-model="baseInforForm.frdb" placeholder="Legal Representative"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="1">&nbsp;</el-col>
            <el-col :span="11">
              <el-form-item prop="frdbdh" label="Legal Representative's Phone">
                <el-input size="small" v-model="baseInforForm.frdbdh" placeholder="Legal Representative's Phone"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="1">&nbsp;</el-col>
          </el-row>
          <el-row class="tr mb5">
            <el-col :span="11">
              <el-form-item prop="lxr" label="Contact Person">
                <el-input size="small" v-model="baseInforForm.lxr" placeholder="Contact Person"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="1">&nbsp;</el-col>
            <el-col :span="11" v-if="userType=='ZSYH'">
              <el-form-item prop="email" label="Email">
                <el-input disabled size="small" v-model="baseInforForm.email" placeholder="Email">
                  <el-button id="email-btn" slot="append" @click="openEmail" v-text=emailCodeText1 :disabled=emailBtnDisable></el-button>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="11" v-else>
              <el-form-item prop="email" label="Email">
                <el-input size="small" v-model="baseInforForm.email" placeholder="Email">
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="1">&nbsp;</el-col>
          </el-row>
          <el-row class="tr mb5">
            <el-col :span="11">
              <el-form-item prop="lxrsj" label="Contact Person's Phone">
                <el-input size="small" v-model="baseInforForm.lxrsj" placeholder="Contact Person's Phone"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="1">&nbsp;</el-col>
            <el-col :span="11" v-if="userType=='ZSYH'">
              <el-form-item prop="dzyx1" label="Standby Email">
                <el-input size="small" v-model="baseInforForm.dzyx1" placeholder="For Password Retrieve" @change="dzyxChange()">
                  <el-button id="mail-btn" slot="append" @click="openYxYz" v-text=mailCodeText :disabled=mailBtnDisable></el-button>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="11" v-else>
              <el-form-item prop="dzyx1" label="Standby Email">
                <el-input size="small" v-model="baseInforForm.dzyx1" placeholder="For Password Retrieve" @change="dzyxChange()">
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="tr mb5">
            <el-col :span="11">
              <el-form-item prop="wz" label="Company Website" >
                <el-input size="small" v-model="baseInforForm.wz" placeholder="Company Website" ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="1">&nbsp;</el-col>
          </el-row>

          <el-row class="mb5" style="border-bottom:1px solid #463132;line-height: 29px;">
            <el-col :span="24">
              <strong style="color: #463132;">
                <span style="color: red">*</span>&nbsp;Sign-up file or brochure</strong>
            </el-col>
          </el-row>
          <el-row style="margin-top:20px">
            <el-col :span="11">
              <el-upload class="upload-demo"
              :on-remove="handleRemove"
              :action="upload_action"
              :on-error="uploadError"
              :headers="myHeaders"
              :before-upload="beforeUpload"
              :on-success="handleAvatarSuccess"
              :file-list="fileList"
              accept=".jpg,.png,.pdf"
              >
                <el-button size="small" icon="el-icon-upload2" plain type="primary">Upload</el-button>
                <span slot="tip" class="el-upload__tip" style="margin-left: 16px;">
                  <font color="red">less than 5mb</font>
                </span>
              </el-upload>
            </el-col>
            <el-col :span="1">&nbsp;</el-col>
          </el-row>
          <el-row class="buttonSubmit">
            <el-col :span="24">
              <el-button v-if="jbxxData.validateFlag=='T'" type="info" icon="el-icon-close" size="small" class="btn_submit" @click="cancel()">Cancel</el-button>
              <el-button type="success" icon="el-icon-check" size="small" class="btn_submit" @click="submitJbxx('baseInforForm')">Save</el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <!--邮箱验证dialog-->
      <el-dialog title="Standby Email Verify" :visible.sync="dialogYxFormVisible" @close="closeYxDialog()" :close-on-click-modal="false">
        <el-form class="el-form demo-form-inline" ref="yxform" :model="yxform" label-width="150px" label-position="right">
          <el-row class="tr mb5" style="text-align: left;margin-left: 10px">
            Please enter the verification code received by
            <span v-text="this.baseInforForm.dzyx1" style="font-style:italic;margin-right: 2px;color: red"></span>
          </el-row>
          <el-row class="tr mb5">
            <el-col :span="22">
              <el-form-item prop="yzm" label="Verification Code">
                <el-input size="small" v-model="yxform.yzm" placeholder="Verification Code"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="2">&nbsp;</el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click.native="closeYxDialog()">Cancel</el-button>
          <el-button size="small" type="primary" @click.native="yxformSubmit()">Submit</el-button>
        </div>
      </el-dialog>
      <!--email验证dialog-->
      <el-dialog title="Change Email" :visible.sync="dialogEmailFormVisible" @close="closeEmailDialog()" :close-on-click-modal="false">
        <el-form class="el-form demo-form-inline" ref="emailform" :model="emailform" :rules="emailRules" label-width="150px" label-position="right">
          <el-row class="tr mb5">
            <el-col :span="22">
              <el-form-item prop="email" label="New Email">
                <el-input size="small" v-model="emailform.email" placeholder="Email">
                  <el-button id="email-btn2" slot="append" @click="getEMessageCode()" v-text=emailCodeText :disabled=emailBtnDisable></el-button>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="2">&nbsp;</el-col>
          </el-row>
          <el-row class="tr mb5">
            <el-col :span="22">
              <el-form-item prop="yzm" label="Verification Code">
                <el-input size="small" v-model="emailform.yzm" placeholder="Verification Code"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="2">&nbsp;</el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click.native="closeEmailDialog()">cancel</el-button>
          <el-button size="small" type="primary" @click.native="emailformSubmit()">Submit</el-button>
        </div>
      </el-dialog>
  </div>

  <!--详情展示-->
  <div class="main-container" element-loading-text="加载中" v-if="!editFlag">
      <div id="qyjbxx" class="mb5">
        <!--英文-->
        <el-row >
          <el-row class="mb10">
            <el-col :span="1">&nbsp;</el-col>
            <el-col :span="21">
              <strong>Company Name：</strong>
              <span v-text="jbxxData.ywgsmc||'no'"></span>
            </el-col>
            <el-col :span="2">
              <el-button type="primary" icon="el-icon-edit" size="small" class="btn_submit" @click="editClick()">Edit</el-button>
            </el-col>
          </el-row>
          <el-row class="mb10">
            <el-col :span="1">&nbsp;</el-col>
            <el-col :span="22">
              <strong>Company Address：</strong>
              <span v-text="jbxxData.yjdz||'no'"></span>
            </el-col>
          </el-row>
          <el-row class="mb10">
            <el-col :span="1">&nbsp;</el-col>
            <el-col :span="11">
              <strong>Postal Code：</strong>
              <span v-text="jbxxData.reserve2||'no'"></span>
            </el-col>
            <el-col :span="11">
              <strong>Legal Representative：</strong>
              <span v-text="jbxxData.frdb||'no'"></span>
            </el-col>
          </el-row>
          <el-row class="mb10">
            <el-col :span="1">&nbsp;</el-col>
            <el-col :span="11">
              <strong>Phone：</strong>
              <span v-text="jbxxData.bgdh||'no'"></span>
            </el-col>
            <el-col :span="11">
              <strong>Legal Representative's Phone：</strong>
              <span v-text="jbxxData.frdbdh||'no'"></span>
            </el-col>
          </el-row>
          <el-row class="mb10">
            <el-col :span="1">&nbsp;</el-col>
            <el-col :span="11">
              <strong>Fax：</strong>
              <span v-text="jbxxData.cz||'no'"></span>
            </el-col>
            <el-col :span="11">
              <strong>Contact Person：</strong>
              <span v-text="jbxxData.lxr||'no'"></span>
            </el-col>
          </el-row>
          <el-row class="mb10">
            <el-col :span="1">&nbsp;</el-col>
            <el-col :span="11">
              <strong>Email：</strong>
              <span v-text="jbxxData.email||'no'"></span>
            </el-col>
            <el-col :span="11">
              <strong>Contact Person's Phone：</strong>
              <span v-text="jbxxData.lxrsj||'no'"></span>
            </el-col>
          </el-row>
          <el-row class="mb10">
            <el-col :span="1">&nbsp;</el-col>
            <el-col :span="11">
              <strong>Standby Email for Password Retrieve：</strong>
              <span v-text="jbxxData.dzyx||'no'"></span>
            </el-col>
            <el-col :span="11">
              <strong>Company Website：</strong>
              <span v-text="jbxxData.wz||'no'"></span>
            </el-col>
          </el-row>
          <!-- add by yushch 20200417-->
          <el-row class="mb10">
            <el-col :span="1">&nbsp;</el-col>
            <el-col :span="22">
              <strong>Sign-up file or brochure：</strong>
              <a @click="download()"><span v-text="jbxxData.srcmc"></span></a>
            </el-col>
          </el-row>
        </el-row>
      </div>
  </div>
      
</div>
  
</template>

<script>
export default {
  props:{
    qyid: {
      type: String,
      required: true
    },
  
  },
  name: "baseInfoEdit",
  data() {
    return {
      baseUrl: window.config.baseUrl,
      myHeaders: { XTOKEN: localStorage.getItem("XTOKEN") },

      //上传路径
      upload_action: window.config.domain + "/qyjbxx/uploadFile",
      //当前用户
      currentUser: this.CONSTANT.currentUser,
      userType: this.CONSTANT.currentUser.deptid,
     
      //显示加载中样
      loading: false,
      //状态 0新增
      jbxxStatus: 0,
      
     
      //进度条
      active: 0,
      //要删除的图片路径list
      delPicList: [],
      delPicSrc: "",
      //上传后未保存的图片list
      unsavedPicList: [],
      fileList: [],
      //曾用公司名称
      cygsmc: "",
      //基本信息表单
      baseInforForm: {
        ywgsmc: "",
        frdb: "",
        frdbdh: "",
        yjdzsheng: "",
        yjdzshi: "",
        yjdzxx: "",
        bgdh: "",
        cz: "",
        lxr: "",
        lxrsj: "",
        wz: "",
        dzyx: "",
        dzyx1: "",
        yyzz: "",
        email: "",
        ywgsjc:"",
        src:""
      },
      //基本信息显示标识
      isJbxxShow: true,
       //邮箱表单显示标识
      dialogYxFormVisible: false,
      //email表单显示标识
      dialogEmailFormVisible: false,
      //邮箱验证flag
      mailCheck: false,
      //邮箱验证按钮可用flag
      emailBtnDisable: false,
      //关联邮箱验证按钮可用flag
      mailBtnDisable: false,
      //通过验证的邮箱地址（记录以防验证后修改邮箱）
      checkedMailAddress: "",
      //邮箱验证码
      mailCodeReal: "",
      //email邮箱验证码
      emailCodeReal: "",
      //邮箱验证按钮文字
      mailCodeText: "verify",
      //email验证按钮
      emailCodeText: "verify",
      emailCodeText1: "change",
      time: 60,
      timer: null,
      time2: 60,
      timer2: null,
      //上传加参数
      upLoadData: {
        qyid: ""
      },
      //邮箱验证表单
      yxform: {
        yzm: ""
      },
      emailform: {
        email: "",
        yzm: ""
      },
      baseInforRules: {
        ywgsmc: [
          {
            required: true,
            message: "Company name is required",
            trigger: "blur"
          },
        
          { validator: (rule, value, callback) => {
            if (value) {
              if (/[\u4E00-\u9FA5]/g.test(value)) {
                callback(new Error('Include Chinese characters'));
              } else {
                callback();
              }
            }
            callback();
            }, trigger: 'blur' },
          {
            min: 1,
            max: 200,
            message: "Less than 200 characters",
            trigger: "blur"
          }
        ],
        yjdzxx: [
          {
            required: true,
            message: "Company address is required",
            trigger: "blur"
          },
          
          { validator: (rule, value, callback) => {
            if (value) {
              if (/[\u4E00-\u9FA5]/g.test(value)) {
                callback(new Error('Include Chinese characters'));
              } else {
                callback();
              }
            }
            callback();
            }, trigger: 'blur' },
          {
            min: 1,
            max: 200,
            message: "Less than 200 characters",
            trigger: "blur"
          }
        ],
        bgdh: [
          {
            required: true,
            message: "Phone number is required",
            trigger: "blur"
          },
         
          { validator: (rule, value, callback) => {
            if (value) {
              if (/[\u4E00-\u9FA5]/g.test(value)) {
                callback(new Error('Include Chinese characters'));
              } else {
                callback();
              }
            }
            callback();
            }, trigger: 'blur' }
        ],
        frdb: [
          {
            required: true,
            message: "Legal Representative is required",
            trigger: "blur"
          },
         
          { validator: (rule, value, callback) => {
            if (value) {
              if (/[\u4E00-\u9FA5]/g.test(value)) {
                callback(new Error('Include Chinese characters'));
              } else {
                callback();
              }
            }
            callback();
            }, trigger: 'blur' },
          {
            min: 1,
            max: 50,
            message: "Less than 50 characters",
            trigger: "blur"
          }
        ],
        frdbdh: [
          {
            required: true,
            message: "Legal Representative's Phone is required",
            trigger: "blur"
          },
          /*
          {
            pattern: /^[\d\-]+$/,
            message: "Number and hyphen only",
            trigger: "blur"
          },*/
          { validator: (rule, value, callback) => {
            if (value) {
              if (/[\u4E00-\u9FA5]/g.test(value)) {
                callback(new Error('Include Chinese characters'));
              } else {
                callback();
              }
            }
            callback();
            }, trigger: 'blur' },
          {
            min: 1,
            max: 30,
            message: "Less than 30 characters",
            trigger: "blur"
          }
        ],
        lxr: [
          {
            required: true,
            message: "Contact Person is required",
            trigger: "blur"
          },
          
          { validator: (rule, value, callback) => {
            if (value) {
              if (/[\u4E00-\u9FA5]/g.test(value)) {
                callback(new Error('Include Chinese characters'));
              } else {
                callback();
              }
            }
            callback();
            }, trigger: 'blur' },
          {
            min: 1,
            max: 50,
            message: "Less than 50 characters",
            trigger: "blur"
          }
        ],
        lxrsj: [
          {
            required: true,
            message: "Contact Person's Phone is required",
            trigger: "blur"
          },
         
          { validator: (rule, value, callback) => {
            if (value) {
              if (/[\u4E00-\u9FA5]/g.test(value)) {
                callback(new Error('Include Chinese characters'));
              } else {
                callback();
              }
            }
            callback();
            }, trigger: 'blur' },
          {
            min: 1,
            max: 30,
            message: "Less than 30 characters",
            trigger: "blur"
          }
        ],
        wz: [
          {
            required: false,
            message: "Company Website is required",
            trigger: "blur"
          },
         
          { validator: (rule, value, callback) => {
            if (value) {
              if (/[\u4E00-\u9FA5]/g.test(value)) {
                callback(new Error('Include Chinese characters'));
              } else {
                callback();
              }
            }
            callback();
            }, trigger: 'blur' },
          {
            min: 1,
            max: 100,
            message: "Less than 100 characters",
            trigger: "blur"
          }
        ],
        dzyx1: [
          {
            required: false,
            message: "Standby Email is required",
            trigger: "blur"
          },
     
          {
            min: 1,
            max: 30,
            message: "Less than 30 characters",
            trigger: "blur"
          }
        ],
        email: [
          { required: true, message: "Email is required", trigger: "blur" },
       
          {
            min: 1,
            max: 30,
            message: "Less than 30 characters",
            trigger: "blur"
          }
        ],
        reserve2: [
          {
            required: false,
            message: "Postal Code is required",
            trigger: "blur"
          },
          { pattern: /^[0-9]*$/, message: "Number only", trigger: "blur" },
          {
            min: 1,
            max: 36,
            message: "Less than 36 characters",
            trigger: "blur"
          }
        ],
        cz: [
          {
            required: false,
            message: "Fax is required",
            trigger: "blur"
          },
          {
            min: 1,
            max: 30,
            message: "Less than 30 characters",
            trigger: "blur"
          }
        ],
        ywgsjc: [
          { required: true, message: "Company short name is required", trigger: "blur" },
          { pattern: /^[^\s]*$/, message: "Not more than 1 word", trigger: "blur" },
          { validator: (rule, value, callback) => {
            if (value) {
              if (/[\u4E00-\u9FA5]/g.test(value)) {
                callback(new Error('Include Chinese characters'));
              } else {
                callback();
              }
            }
            callback();
            }, trigger: 'blur' }
        ],
      },
       emailRules: {
        email: [
          { required: true, message: "Email is required", trigger: "blur" },
          {
            min: 1,
            max: 30,
            message: "Less than 30 characters",
            trigger: "blur"
          }
        ],
        yzm: [
          {
            required: true,
            message: "Verification Code is required",
            trigger: "blur"
          }
        ]
      },
      editFlag: false,
      jbxxData: {},
    };
  },
  watch: {
    qyid(){
      if(this.qyid == 'newInsert'){
        this.editFlag = true;
      }else if(this.qyid != ''){
        this.findInfoByQyid(this.qyid);
      }
    }
  },
  created: function() {
  },
 
  methods: {
    //通过企业id查询基本信息数据
    findInfoByQyid: function(qyid) {
      this.$emit("getLoading", true);
      var params = {
        qyid: qyid,
        deleteFlag: "N"
      };
      let vm = this;
      vm.$axios.post("/qyjbxx/doFindByVo", params).then(
        function(res) {
          if (res.data.result != null && res.data.result != "") {
            if ( vm.currentUser.deptid == "GLYH" || res.data.result.sjzt == "01" || res.data.result.sjzt == "04") {
              
                vm.jbxxData = JSON.parse(JSON.stringify(res.data.result));
                
                //add by yushch 20200416
                if(vm.jbxxData.src!= null){
                  let arr = vm.jbxxData.src.split("/");
                  vm.jbxxData.srcmc = arr[arr.length-1];
                }
                //end
                if(vm.jbxxData.src != ""){
                  vm.jbxxData.imageUrl = vm.baseUrl + "/upload/" + vm.jbxxData.src;
                }
                vm.jbxxData.yjdz = vm.jbxxData.yjdzshengmc + vm.jbxxData.yjdzshimc + vm.jbxxData.yjdzxx;
            
              
                //编辑中，已驳回
                vm.cygsmc = res.data.result.ywgsmc;
                let tempForm =  res.data.result;
                tempForm.dzyx1 = tempForm.dzyx;
                vm.baseInforForm = tempForm;
                //end modify
                //add by yushch 20200416 英文基本信息附件回显
                if(vm.baseInforForm.src != null){
                  vm.fileList = [];
                  let arr = vm.baseInforForm.src.split("/");
                  vm.fileList.push({
                    name: arr[arr.length-1], //upload控件显示名称
                    url: vm.baseInforForm.src,
                  });
                }
                //vm.jbxxStatus = 1; //修改
                vm.qyid = res.data.result.qyid;
                vm.upLoadData.qyid = res.data.result.qyid;
                vm.$emit("getbaseInforData", vm.baseInforForm);
                //vm.$emit("getQyid",  vm.qyid);
              if(res.data.result.validateFlag == 'T'){
                vm.editFlag = false;
              }else{
                vm.editFlag = true;
              }

            } else {
              //已提交，已审核 直接跳转到确认页
              this.$router.replace({
                name:"exhpredictionConfirm",
                query: { userid: vm.currentUser.userid, type: "BJ" }
              });
            }
          }else{
            //location.reload();
          }
          vm.$emit("getLoading", false);
          //展商用户校验改没改密码
          if(vm.userType == "ZSYH"){
            //vm.checkPasswordChg();
          }
        }.bind(vm),
        function(error) {
          console.log(error);
        }
      );
    },
    
    
    
   

    checkPasswordChg: function(){
      let vm = this;
      var passwordChgFlag = vm.currentUser.passwordChgFlag;
      if (passwordChgFlag == "F") {
        vm.$alert(
          "为保证信息安全，请点击右上角用户名，前往用户中心，按照密码校验规则修改密码",
          '提示',
          {
            confirmButtonText: '确定',
            type: 'warning'
          });
      }
    },
   
   
    //英文展商下载附件 add by yushch 20200416
    download: function(){
      window.open(window.config.domain + "/qyjbxx/downloadFj?src="+this.jbxxData.src);
    },
    //修改邮箱，默认是登录名
    openEmail: function() {
      this.dialogEmailFormVisible = true;
      // $("#email-btn").attr("disabled", "disabled");
      //this.emailBtnDisable = true;
    },
    //email提交
    emailformSubmit: function() {
      if (this.emailform.email != null && this.emailform.email != "") {
        if (
          this.emailform.yzm == this.emailCodeReal &&
          this.emailCodeReal != ""
        ) {
          this.baseInforForm.email = this.emailform.email;
          this.dialogEmailFormVisible = false;
          //  $("#email-btn").removeAttr("disabled");
          this.emailBtnDisable = false;
          //  $("#email-btn2").removeAttr("disabled");
          this.$message({
            message: "success",
            type: "success"
          });
        } else {
          this.$message({
            message: "Error Verification Code",
            type: "warning"
          });
        }
      } else {
        this.$message({
          message: "Email is required",
          type: "warning"
        });
      }
    },
    //邮箱修改验证
    openYxYz: function() {
      let vm = this;
    /*  if (
        !/^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@[0-9A-Za-z]+(?:\.[0-9A-Za-z]+)+$/.test(
          vm.baseInforForm.dzyx1
        )
      ) {
        vm.$message({
          message: "error email",
          type: "warning"
        });
        return false;
      } else {
      */
        //查询邮箱是否注册
        vm.$axios
          .get("/qyjbxx/getMailNum/" + vm.baseInforForm.dzyx1 + "/static")
          .then(
            function(res) {
              if (res.data.result == 0) {
                vm.mailCodeText = "sending...";
                //$("#mail-btn").attr("disabled", "disabled");
                vm.mailBtnDisable = true;
                vm.$axios
                  .get("/signin/sendMailEng?mail=" + vm.baseInforForm.dzyx1)
                  .then(
                    function(res) {
                      vm.mailCodeReal = res.data.msg;
                      var count = vm.time;
                      vm.timer = setInterval(() => {
                        if (count == 0) {
                          clearInterval(vm.timer);
                          vm.timer = null;
                          vm.mailCodeText = "verify";
                          //$("#mail-btn").removeAttr("disabled");
                          vm.mailBtnDisable = false;
                        } else {
                          vm.mailCodeText = count + "s";
                          count--;
                          //$("#mail-btn").attr("disabled", "disabled");
                          vm.mailBtnDisable = true;
                        }
                      }, 1000);
                      vm.dialogYxFormVisible = true;
                    }.bind(vm),
                    function(error) {
                      console.log(error);
                    }
                  );
              } else if (vm.baseInforForm.dzyx1 == vm.baseInforForm.dzyx) {
                vm.$message({
                  message: "success!",
                  type: "success"
                });
                return false;
              } else {
                vm.$message({
                  message: "This email address has been used!",
                  type: "warning"
                });
                return false;
              }
            }.bind(vm),
            function(error) {
              console.log(error);
            }
          );
    //  }
    },
    getEMessageCode: function() {
      let vm = this;
      /*
      if (
        !/^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@[0-9A-Za-z]+(?:\.[0-9A-Za-z]+)+$/.test(
          vm.emailform.email
        )
      ) {
        vm.$message({
          message: "Error Email",
          type: "warning"
        });
        return false;
      } else {
      */
        vm.emailCodeText = "sending...";
        vm.emailCodeText1 = "sending...";
        //$("#email-btn").attr("disabled", "disabled");
        vm.emailBtnDisable = true;
        //  $("#email-btn2").attr("disabled", "disabled");
        vm.$axios.get("/signin/sendMailEng?mail=" + vm.emailform.email).then(
          function(res) {
            vm.emailCodeReal = res.data.msg;
            var count = vm.time2;
            vm.timer2 = setInterval(() => {
              if (count == 0) {
                clearInterval(vm.timer2);
                vm.timer2 = null;
                vm.emailCodeText = "verify";
                vm.emailCodeText1 = "change";
                //$("#email-btn").removeAttr("disabled");
                vm.emailBtnDisable = false;
                // $("#email-btn2").removeAttr("disabled");
              } else {
                vm.emailCodeText = count + "s";
                vm.emailCodeText1 = count + "s";
                count--;
                //$("#email-btn").attr("disabled", "disabled");
                vm.emailBtnDisable = true;
                // $("#email-btn2").attr("disabled", "disabled");
              }
            }, 1000);
          }.bind(vm),
          function(error) {
            console.log(error);
          }
        );
    //  }
    },
    //关闭邮箱验证对话
    closeYxDialog: function() {
      this.dialogYxFormVisible = false;
      this.yxform.yzm = "";
      this.$refs["yxform"].resetFields();
    },
    //关闭email
    closeEmailDialog: function() {
      this.dialogEmailFormVisible = false;
      this.emailform.email = "";
      this.emailform.yzm = "";
      //$("#email-btn").removeAttr("disabled");
      this.emailBtnDisable = false;
      // $("#email-btn2").removeAttr("disabled");
      this.$refs["emailform"].resetFields();
    },
    //邮箱change判断需不需要重新验证
    dzyxChange: function() {
      if (
        this.checkedMailAddress != this.baseInforForm.dzyx1 &&
        this.checkedMailAddress != ""
      ) {
        this.mailCheck = false;
      }
    },
    //邮箱验证表单提交
    yxformSubmit: function() {
      if (this.yxform.yzm == this.mailCodeReal) {
        this.mailCheck = true;
        this.checkedMailAddress = this.baseInforForm.dzyx1;
        this.dialogYxFormVisible = false;
        this.$message({
          message: "success",
          type: "success"
        });
        this.mailCodeText = "verify";
      } else {
        this.$message({
          message: "Error Verification Code",
          type: "error"
        });
      }
    },
    //删除附件确认
    beforeRemove(file, fileList) {
      return this.$confirm(`Are you sure to remove ${file.name}?`);
    },
    //上传附件前校验
    beforeUpload(file, fileList) {
      return new Promise((resolve,reject) => {
        var fileName = file.name.lastIndexOf("."); //取到文件名开始到最后一个点的长度
        var fileNameLength = file.name.length; //取到文件名长度
        var fileFormat = file.name.substring(fileName + 1, fileNameLength);
        const isPng = fileFormat.toLowerCase() == "png";
        const isJpg = fileFormat.toLowerCase() == "jpg";
        this.isPdf = fileFormat.toLowerCase() == "pdf";
        const filemax = file.size / 1024 / 1024 < 5;
        if (!isPng && !isJpg && !this.isPdf) {
          this.$message.error("File has to be endswith png jpg or pdf");
          return reject(false);
        }else if (!filemax) {
          this.$message.error("File has to be less than 5mb");
          return reject(false);
        }
        return resolve(true);
      });

    },
    //上传成功
    handleAvatarSuccess(res, file) {
      if (file.status == "success") {
        this.baseInforForm.src = res.src;
        this.fileList.push({
          name: file.name, //upload控件显示名称
          url: file.response.src,
        });
        if (this.fileList.length > 0) {
         this.fileList = [this.fileList[this.fileList.length - 1]];
        }
      } else {
        this.$message.error("upload failed");
      }
    },
    //上传失败
    uploadError(err, file, fileList) {
      this.$message.error("upload failed");
    },
    //删除附件
    handleRemove(file, fileList) {
      this.baseInforForm.src = '';
    },

    //基本信息提交（下一步）
    submitJbxx: function(formName) {
      let vm = this;
      vm.$refs[formName].validate(valid => {
        if (valid) {
          if (vm.qyid == 'newInsert') {
            //新增
            if (vm.baseInforForm.dzyx1 != "" && vm.mailCheck == false && vm.userType == 'ZSYH'
            ) {
              vm.$message({
                message: "Please verify the Standby Email",
                type: "warning"
              });
              return false;
            } else if (
              vm.baseInforForm.src == null ||
              vm.baseInforForm.src == ""
            ) {
              vm.$message({
                message: "Sign-up file or brochure is required",
                type: "warning"
              });
              return false;
            } else {
               vm.$emit("getLoading", true);
              var params = {
              //  userid: vm.currentUser.userid,
                ywgsmc: vm.baseInforForm.ywgsmc,
                frdb: vm.baseInforForm.frdb,
                frdbdh: vm.baseInforForm.frdbdh,
                yjdzxx: vm.baseInforForm.yjdzxx,
                bgdh: vm.baseInforForm.bgdh,
                cz: vm.baseInforForm.cz,
                lxr: vm.baseInforForm.lxr,
                lxrsj: vm.baseInforForm.lxrsj,
                wz: vm.baseInforForm.wz,
                dzyx: vm.baseInforForm.dzyx1,
                email: vm.baseInforForm.email,
                sjzt: "01", //编辑中
                deleteFlag: "N",
                cjrid: vm.currentUser.userid,
                cjrmc: vm.currentUser.username,
                reserve2: vm.baseInforForm.reserve2, //邮政编码
                ywgsjc: vm.baseInforForm.ywgsjc,
                xgrid: vm.currentUser.userid,
                xgrmc: vm.currentUser.username,
                src: vm.baseInforForm.src,
                validateFlag: 'T'
              };
              //add by yushch 20200414 管理员登录userid带入选择的企业userid
              if(vm.userType == 'ZSYH'){
                params.userid = vm.currentUser.userid;
              }else{
                params.userid = vm.baseInforForm.userid;
              }
              //end add
              vm.$axios.post("/qyjbxx/doInsertByVo", params).then(
                function(res) {
                  if (res.data.result != null && res.data.result != "") {
                    vm.$message({
                      message: "Brief Company Information has been saved!",
                      type: "success"
                    });
                    vm.$emit("getLoading", false);
                    //vm.$emit("getActive",  1);
                    vm.qyid = res.data.result.qyid;
                    vm.$emit("getQyid",  vm.qyid);
                    vm.baseInforForm.qyid = res.data.result.qyid;
                    vm.upLoadData.qyid = res.data.result.qyid;

                    vm.editFlag = false;
                    this.findInfoByQyid(this.qyid);
                  } else {
                    vm.$message({
                      message: "Brief Company Information save failed!",
                      type: "error"
                    });
                     vm.$emit("getLoading", false);
                  }
                }.bind(vm),
                function(error) {
                  console.log(error);
                }
              );
            }
          } else {
            //修改
            //邮箱修改且邮箱验证通过flag为false
            if (
              vm.baseInforForm.dzyx1 != null &&
              vm.baseInforForm.dzyx1 != "" &&
              vm.baseInforForm.dzyx1 != undefined &&
              vm.baseInforForm.dzyx != vm.baseInforForm.dzyx1 &&
              vm.mailCheck == false &&
              vm.userType == 'ZSYH'
            ) {
              vm.$message({
                message: "Please verify the Standby Email",
                type: "warning"
              });
              return false;
            }else if (
              vm.baseInforForm.src == null ||
              vm.baseInforForm.src == ""
            ) {
              vm.$message({
                message: "Sign-up file or brochure is required",
                type: "warning"
              });
              return false;
            } else {
              vm.$emit("getLoading", true);
              var params = {
                  qyid: vm.baseInforForm.qyid,
                  ywgsmc: vm.baseInforForm.ywgsmc,
                  frdb: vm.baseInforForm.frdb,
                  frdbdh: vm.baseInforForm.frdbdh,
                  yjdzxx: vm.baseInforForm.yjdzxx,
                  bgdh: vm.baseInforForm.bgdh,
                  cz: vm.baseInforForm.cz,
                  lxr: vm.baseInforForm.lxr,
                  lxrsj: vm.baseInforForm.lxrsj,
                  wz: vm.baseInforForm.wz,
                  dzyx: vm.baseInforForm.dzyx1,
                  email: vm.baseInforForm.email,
                  reserve2: vm.baseInforForm.reserve2,
                  xgrid: vm.currentUser.userid,
                  xgrmc: vm.currentUser.username,
                  ywgsjc: vm.baseInforForm.ywgsjc,
                  src: vm.baseInforForm.src,
                  validateFlag:'T',
                };
              //判断当前公司名称是否修改
              if (vm.cygsmc != vm.baseInforForm.ywgsmc) {
                params.cygsmc = vm.cygsmc;
              }
              vm.$axios.post("/qyjbxx/doUpdateByVO", params).then(
                function(res) {
                  if (res.data.result > 0) {
                    vm.$emit("getLoading", false);
                    vm.cygsmc = vm.baseInforForm.ywgsmc;
                    vm.upLoadData.qyid = vm.baseInforForm.qyid;
                    vm.$message({
                      message: "Brief Company Information has been saved!",
                      type: "success"
                    });
                    //vm.$emit("getActive",  1);

                    vm.editFlag = false;
                    this.findInfoByQyid(this.qyid);
                  } else {
                    vm.$message({
                      message: "Brief Company Information save failed",
                      type: "error"
                    });
                    vm.loading = false;
                  }
                }.bind(vm),
                function(error) {
                  console.log(error);
                }
              );
            }
          }
        } else {
          setTimeout(() => {
              var isError = document.getElementsByClassName("is-error");
              isError[0].querySelector('input,textarea').focus();
            }, 100);
          console.log("error submit!!");
          return false;
        }
      });
    },

    editClick: function(){
      this.editFlag = true;
    },
    cancel: function(){
      this.findInfoByQyid(this.qyid);
    }
  }
};
</script>

<style lang="scss">
#baseInfoEdit {
  .mb5 {
    margin-bottom: 5px;
  }
  
  .el-card__body {
    padding: 10px 0px 10px 0px;
  }
  .el-message {
    z-index: 10005 !important;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
  }
  .avatar {
    width: 100px;
    height: 100px;
    display: block;
  }
  .el-dialog {
    width: 45%;
  }
  .el-button--small {
    padding: 9px 9px;
  }

  .card_title_font{
    line-height: 40px;
  }
  .clearfix{
    height: 40px;
  }
  
  #previewImgDialog .el-dialog {
    background-color: rgba(0, 0, 0, 0.2);
  }
}
</style>



// WEBPACK FOOTER //
// src/views/exhibition/prediction/exhprediction/exhpredictionEditEng/BaseInfo.vue